export function getRootPath(): string {
    let rootPath = TRPCONFIG.RootPath;
    return /\/$/.test(rootPath) ? rootPath : rootPath + '/';
}
